import { render, staticRenderFns } from "./TypesTable.vue?vue&type=template&id=2bc3cce0&scoped=true&"
import script from "./TypesTable.vue?vue&type=script&lang=js&"
export * from "./TypesTable.vue?vue&type=script&lang=js&"
import style0 from "./TypesTable.vue?vue&type=style&index=0&id=2bc3cce0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bc3cce0",
  null
  
)

export default component.exports